import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    TableCell
} from '@material-ui/core';


class CustomTableCell extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        width: PropTypes.string
    };

    constructor (props) {
        super(props);

    }

    render () {
        const { classes, className, width, children, ...otherProps } = this.props;

        const style = {};
        if (width) {
            style.width = width;
            style.maxWidth = 0;
        }

        return (
            <TableCell
                classes={{ root: classnames(classes.tableCellRoot, className) }}
                style={style}
                {...otherProps}
            >
                {children}
            </TableCell>
        );
    }
}

const style = theme => ({
    tableCellRoot: {
        ...theme.typography.body2,
        borderBottom: 'initial',
        height: theme.constants.tableRowHeight,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 0,
        '&:first-child': {
            paddingLeft: theme.constants.horizontalMargin
        },
        '&:last-child': {
            paddingRight: theme.constants.horizontalMargin
        }
    }
});

export default withStyles(style)(CustomTableCell);